import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import Button from '~/components/Button';

import { ChevronDownIcon, ChevronUpIcon } from '../icons';

const propTypes = {
  isFiltersBoxVisible: PropTypes.bool,
  hasFilterSet: PropTypes.bool,
};

const OpenFiltersButton = ({ isFiltersBoxVisible, hasFilterSet, ...props }) => (
  <Button
    colorScheme="primary"
    fontSize="md"
    letterSpacing={0}
    variant="ghost"
    textTransform="none"
    fontWeight="normal"
    {...props}
  >
    Sort | Filters
    {isFiltersBoxVisible ? (
      <ChevronUpIcon boxSize="24px" />
    ) : (
      <ChevronDownIcon boxSize="24px" />
    )}
    {hasFilterSet && (
      <Box
        backgroundColor="error.500"
        width="8px"
        height="8px"
        borderRadius="50%"
        pos="absolute"
        top="10px"
        left="4px"
      />
    )}
  </Button>
);

OpenFiltersButton.propTypes = propTypes;

export default OpenFiltersButton;
